import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27bc6734"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "create-order-box"
};
const _hoisted_2 = {
  key: 0,
  class: "warning"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 请在下订单额后五分钟内完成支付，超时订单将失效 ");
const _hoisted_4 = {
  key: 0,
  class: "address-box"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "地区", -1));
const _hoisted_6 = {
  class: "info"
};
const _hoisted_7 = {
  class: "item bottom"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "手机号", -1));
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "address"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_13 = {
  key: 1,
  class: "address-box"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address-line"
}, null, -1));
const _hoisted_15 = {
  class: "create-order-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回报档", -1));
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 2,
  class: "customized"
};
const _hoisted_20 = {
  class: "create-order-item"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "众筹数量", -1));
const _hoisted_22 = {
  class: "num-box"
};
const _hoisted_23 = {
  key: 0,
  class: "limit-tips"
};
const _hoisted_24 = {
  class: "num"
};
const _hoisted_25 = {
  key: 0,
  class: "create-order-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运费", -1));
const _hoisted_27 = {
  key: 0,
  class: "postage"
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  key: 2
};
const _hoisted_30 = {
  class: "red"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "额外打赏", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打赏", -1));
const _hoisted_33 = {
  class: "create-order-item note"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "填写备注", -1));
const _hoisted_35 = {
  class: "create-order-agreement"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "免责协议：", -1));
const _hoisted_37 = ["innerHTML"];
const _hoisted_38 = {
  class: "create-order-btn"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总额", -1));
const _hoisted_40 = {
  class: "num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_PaymethodList = _resolveComponent("PaymethodList");
  const _component_CompExtra = _resolveComponent("CompExtra");
  const _component_CompcountryCode = _resolveComponent("CompcountryCode");
  const _component_MdConfirm = _resolveComponent("MdConfirm");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.showWarning ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("i", {
    class: "close",
    onClick: _cache[0] || (_cache[0] = $event => $data.showWarning = false)
  })])) : _createCommentVNode("", true), $data.reword_item.id != -3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.reword_item.reward_way == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.checkCountryCode && $options.checkCountryCode(...args))
  }, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString($data.country_name ? $data.country_name : '中国') + " " + _toDisplayString($data.country_code ? '+' + $data.country_code : '+86'), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_van_field, {
    class: "input-info",
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.value = $event),
    placeholder: "请输入手机号码"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", {
    class: "icon",
    onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.goToAddressList && $options.goToAddressList(...args), ["stop"]))
  })])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.addressItem && JSON.stringify($data.addressItem) != '{}' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "address-box",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goToAddressList && $options.goToAddressList(...args))
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("strong", null, _toDisplayString($data.addressItem.address_name), 1), _createElementVNode("span", null, _toDisplayString($data.addressItem.address_mobile), 1), $data.addressItem.is_default ? (_openBlock(), _createElementBlock("i", _hoisted_10, "默认")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, " 收货地址：" + _toDisplayString($data.addressItem.province) + _toDisplayString($data.addressItem.city) + _toDisplayString($data.addressItem.county) + _toDisplayString($data.addressItem.street) + _toDisplayString($data.addressItem.address), 1), _hoisted_12])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goToAddressList && $options.goToAddressList(...args))
  }, "新增收货地址"), _createElementVNode("div", {
    class: "icon",
    onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.goToAddressList && $options.goToAddressList(...args), ["stop"]))
  })]))], 64))], 64)) : _createCommentVNode("", true), _hoisted_14, _createElementVNode("div", _hoisted_15, [_hoisted_16, $data.reword_item.id == -3 ? (_openBlock(), _createElementBlock("div", _hoisted_17, "无偿支持")) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createTextVNode("(" + _toDisplayString($data.reword_item.name) + ") ", 1), _createElementVNode("strong", null, "￥" + _toDisplayString($data.reword_item.money), 1)]))]), $data.reword_item.is_customized ? (_openBlock(), _createElementBlock("div", _hoisted_19, "*该产品为定制产品，众筹成功后不支持无理由退货退款")) : _createCommentVNode("", true), $data.reword_item.id != -3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [$data.reword_item.limit_per_user > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, "每人限购 " + _toDisplayString($data.reword_item.limit_per_user) + " 份 ", 1)) : _createCommentVNode("", true), _createElementVNode("i", {
    class: _normalizeClass(['icon', 'reduce', {
      'gray': $data.total <= 1
    }]),
    onClick: _cache[7] || (_cache[7] = (...args) => $options.onReduce && $options.onReduce(...args))
  }, "-", 2), _createElementVNode("span", _hoisted_24, _toDisplayString($data.total), 1), _createElementVNode("i", {
    class: _normalizeClass(['icon', 'add', {
      'gray': $data.reword_item.limit_per_user && $data.total >= $data.reword_item.limit_per_user
    }]),
    onClick: _cache[8] || (_cache[8] = (...args) => $options.onAdd && $options.onAdd(...args))
  }, "+", 2)])]), $data.reword_item.reward_way != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_hoisted_26, $data.postAgeInfo.postage_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_27, "到付")) : $data.postAgeInfo.postage_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_28, "包邮")) : $data.postAgeInfo.postage_type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_29, "￥" + _toDisplayString($data.postage_total_amount), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mdorderCouponList, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      key: idx,
      class: "create-order-item"
    }, [_createElementVNode("span", null, _toDisplayString(item.coupon_name), 1), _createElementVNode("div", _hoisted_30, "-￥" + _toDisplayString(item.coupon_amount), 1)]);
  }), 128)), _createElementVNode("div", {
    class: "create-order-item",
    onClick: _cache[9] || (_cache[9] = $event => $data.show = true)
  }, [_hoisted_31, _createElementVNode("div", {
    class: _normalizeClass(['additional', {
      'additional-true': $data.extra_money && Number($data.extra_money) > 0
    }])
  }, _toDisplayString(Number($data.extra_money).toFixed(2)), 3)])], 64)) : (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: "create-order-item",
    onClick: _cache[10] || (_cache[10] = $event => $data.show = true)
  }, [_hoisted_32, _createElementVNode("div", {
    class: _normalizeClass(['additional', {
      'additional-true': $data.extra_money && Number($data.extra_money) > 0
    }])
  }, _toDisplayString(Number($data.extra_money).toFixed(2)), 3)])), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createVNode(_component_van_field, {
    class: "input-info",
    modelValue: $data.remark,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.remark = $event),
    placeholder: "选填，可输入特殊要求"
  }, null, 8, ["modelValue"])]), _createVNode(_component_PaymethodList, {
    type: 1,
    id: $data.reword_item.pro_id,
    onSetPayType: $options.setPayType
  }, null, 8, ["id", "onSetPayType"]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", {
    class: "info",
    innerHTML: $options.riskInfo
  }, null, 8, _hoisted_37)]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("strong", _hoisted_40, "￥" + _toDisplayString($options.amount), 1), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[12] || (_cache[12] = (...args) => $options.createOrder && $options.createOrder(...args))
  }, "提交订单")]), _createVNode(_component_CompExtra, {
    show: $data.show,
    "onUpdate:show": _cache[13] || (_cache[13] = $event => $data.show = $event),
    extra_money: $data.extra_money,
    "onUpdate:extra_money": _cache[14] || (_cache[14] = $event => $data.extra_money = $event)
  }, null, 8, ["show", "extra_money"]), _createVNode(_component_CompcountryCode, {
    show: $data.showCountryCode,
    "onUpdate:show": _cache[15] || (_cache[15] = $event => $data.showCountryCode = $event),
    country_code: $data.country_code,
    "onUpdate:country_code": _cache[16] || (_cache[16] = $event => $data.country_code = $event),
    country_name: $data.country_name,
    "onUpdate:country_name": _cache[17] || (_cache[17] = $event => $data.country_name = $event)
  }, null, 8, ["show", "country_code", "country_name"]), _createVNode(_component_MdConfirm, {
    show: $data.showConfirm,
    "onUpdate:show": _cache[18] || (_cache[18] = $event => $data.showConfirm = $event),
    actionText: ['取消', '立即更换'],
    message: $data.confirmMsg,
    onConfirm: $options.goToAddressList
  }, null, 8, ["show", "message", "onConfirm"])]);
}